<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="!windowService.isDesktopRes || backPage?.includes('automatic-booking-property')"
      [title]="tabTitle"
      [customBack]="backPage"
      [linkIcon]="'add-maintenance'"
      [showLinkIcon]="true"
      (linkAction)="onHeaderAddAction()"
/>
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />


<ng-template #content>
  <tidy-wrapper
    [hasBottomNav]="!windowService.isDesktopRes"
    [isPrimaryLayer]="true"
    (contentHeight)="contentHeight = $event">

    @if (windowService?.isDesktopRes) {
      @if (tabs.length > 1) {
        <tidy-desktop-header class="no-bottom-margin">
          <div class="wrappable-container contacts-header-row">
            <tidy-text
              [title]="'Contacts'" />
            <tidy-tabs
              [tabs]="tabs"
              [activeTab]="selectedTab"
              (tabChange)="selectTab($event)" />
          </div>
          <div class="non-wrappable-right-aligned-container">
            <automations-preview-button
              [tag]="'contacts'" />
          </div>
        </tidy-desktop-header>
      }

      @if (selectedTab === 'pros') {
        <tidy-desktop-header #prosHeader>
          <div class="wrappable-container">
            <tidy-text
              [header]="'Pros'" />
            <form [formGroup]="searchForm" novalidate action="#">
              <tidy-search-input
                formControlName="search"
                [placeholder]="'Search'"
                [icon]="'assets/img/search-header.svg'"
                class="header-search" />
            </form>
            <tidy-small-button
              [text]="'Find New Pro'"
              [image]="'assets/img/people.svg'"
              (buttonClick)="goToFindNewPro()" />
            <tidy-small-button
              [text]="'Add Pro'"
              [image]="'assets/img/add-button-white.svg'"
              (buttonClick)="goToAddProAllAddresses()" />
            <tidy-image
              [src]="'assets/img/download_csv.svg'"
              class="desktop-header-icon secondary-text-icon"
              (action)="exportCSV()"/>
            <tidy-image
              [src]="'assets/img/gear.svg'"
              class="desktop-header-icon secondary-text-icon"
              (action)="goToProSettings()"/>
          </div>
          <div class="non-wrappable-right-aligned-container">
            @if (showLoadingSpinner) {
              <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px" />
            }
            @if (tabs.length <= 1) {
              <!-- Single-tab accounts never render the Contacts title header
                   above, which is where the chip normally lives. -->
              <automations-preview-button
                [tag]="'contacts'" />
            }
          </div>
        </tidy-desktop-header>
      }

    }

    @if (selectedTab === 'pros') {
      <!-- Skeleton table while loading — rows float in with the entrance cascade;
           the real table below then replaces it in place, instantly (skipEntrance). -->
      @if (windowService?.isDesktopRes && !loaded) {
        <tidy-table
          [skeletonLoading]="true"
          [columnslabels]="allProHeaders" />
      }

      @if (windowService?.isDesktopRes && loaded) {
        <tidy-card class="no-padding">
          <tidy-table
            #tidyTable
            [dataSource]="shownPros"
            [displayedColumns]="allProHeaders"
            [columnslabels]="allProHeaders"
            [allRowIsClickable]="true"
            [enableVirtualScrolling]="false"
            [skipEntrance]="true"
            (sortChange)="sortChanged($event)"
            (cellClick)="onTableColumnClick($event)"/>
        </tidy-card>
      }

      @if (!windowService?.isDesktopRes) {
        @if (!loaded) {
          <div style="display: flex; width: 100%">
            <ion-skeleton-text
              animated="true"
              style="flex: 0 0 70%; height: 40px; border-radius: 6px; padding-right: 10px" />
            <ion-skeleton-text
              animated="true"
              style="flex: 0 0 30%; height: 40px; border-radius: 6px" />
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px; width: 100%">
            <ion-skeleton-text
              animated="true"
              style="width: 110px; height: 32px; border-radius: 6px" />
            <ion-skeleton-text
              animated="true"
              style="width: 80px; height: 32px; border-radius: 6px" />
            <ion-skeleton-text
              animated="true"
              style="width: 32px; height: 32px; border-radius: 6px" />
          </div>
          @for (_ of [1, 2, 3]; track _) {
            <div style="margin-top: 12px; width: 100%; padding: 16px; border-radius: 6px; background: var(--tidy-primary-layer-card-background)">
              <div style="display: flex; align-items: center; gap: 10px">
                <ion-skeleton-text
                  animated="true"
                  style="width: 36px; height: 36px; border-radius: 50%" />
                <ion-skeleton-text
                  animated="true"
                  style="width: 140px; height: 18px; border-radius: 4px" />
              </div>
              <ion-skeleton-text
                animated="true"
                style="width: 70px; height: 12px; border-radius: 4px; margin-top: 14px" />
              <div style="display: flex; gap: 6px; margin-top: 6px; flex-wrap: wrap">
                <ion-skeleton-text
                  animated="true"
                  style="width: 100px; height: 26px; border-radius: 16px" />
                <ion-skeleton-text
                  animated="true"
                  style="width: 120px; height: 26px; border-radius: 16px" />
              </div>
              <ion-skeleton-text
                animated="true"
                style="width: 55px; height: 12px; border-radius: 4px; margin-top: 14px" />
              <div style="display: flex; gap: 6px; margin-top: 6px">
                <ion-skeleton-text
                  animated="true"
                  style="width: 80px; height: 26px; border-radius: 16px" />
                <ion-skeleton-text
                  animated="true"
                  style="width: 90px; height: 26px; border-radius: 16px" />
              </div>
            </div>
          }
        }
        @if (loaded) {
          <div style="margin-bottom: 10px; display: flex; align-items: center; gap: 8px; width: 100%;">
            <div style="flex: 1; min-width: 0;">
              <form [formGroup]="searchForm" novalidate action="#">
                <tidy-search-input
                  formControlName="search"
                  [placeholder]="'Search'"
                  [icon]="'assets/img/search-header.svg'"
                  [fixedWidth]="false"
                  class="header-search" />
              </form>
            </div>
            @if (allPros?.length) {
              <div style="flex: 0 0 auto;">
                <tidy-small-button
                  [iconOnly]="true"
                  [image]="'assets/img/filter-white.svg'"
                  [matMenuTriggerFor]="filterMenu"
                  [matMenuTriggerDisabled]="showAboutThisPage" />
              </div>
            }
          </div>
          @if (chips?.length > 0) {
            <div class="mobile-filter-chips">
              @for (chip of chips; track chip.value) {
                <ion-chip class="filter-chip">
                  <mat-icon
                    class="chip-icon"
                    [style.color]="chip.color || 'inherit'">{{ chip.icon }}</mat-icon>
                  <ion-label>{{ chip.name }}</ion-label>
                  <ion-icon name="close-circle" (click)="removeFilterChip(chip)" />
                </ion-chip>
              }
            </div>
          }
          @for (pro of shownPros; track pro.proId) {
            <tidy-card>
              <tidy-card-button
                (action)="goToPro(pro.proId)"
                class="arrow-to-top no-padding">
                <tidy-row>
                  <tidy-initials-icon
                    [fullName]="pro['Name'].value" />
                  <tidy-text
                    [header]="pro['Name'].value"
                    [translate]="false" />
                </tidy-row>
              </tidy-card-button>
              @if (pro['Properties']?.length) {
                <div class="pro-card-properties">
                  @for (property of getVisibleProperties(pro); track property.value) {
                    <span class="pro-card-property-item">
                      <ion-icon
                        name="home"
                        [style.color]="property.color"
                        class="pro-card-property-icon" />
                      {{ property.value }}
                    </span>
                  }
                  @if (pro['Properties'].length > 5) {
                    <span
                      class="pro-card-show-more-inline"
                      (click)="toggleProProperties(pro.proId)">
                      {{ expandedProProperties.has(pro.proId) ? 'Show less' : 'Show ' + (pro['Properties'].length - 5) + ' more' }}
                    </span>
                  }
                </div>
              }
              @if (pro['Services']?.length) {
                <div class="pro-card-services">
                  @for (service of getVisibleServices(pro); track service.value) {
                    <span class="pro-card-service-chip">
                      @if (service.icon) {
                        <img
                          [src]="service.icon"
                          class="pro-card-service-icon" />
                      }
                      {{ service.value }}
                    </span>
                  }
                  @if (pro['Services'].length > 5) {
                    <span
                      class="pro-card-show-more-inline"
                      (click)="toggleProServices(pro.proId)">
                      {{ expandedProServices.has(pro.proId) ? 'Show less' : 'Show ' + (pro['Services'].length - 5) + ' more' }}
                    </span>
                  }
                </div>
              }
              @if (pro['Last Job'].value || pro['Next Job'].value) {
                <tidy-row class="extra-top-padding">
                  <tidy-divider />
                </tidy-row>
                <tidy-row
                  class="extra-top-padding"
                  [alignLastItemRight]="true">
                  @if (pro['Last Job'].value) {
                    <div style="display: flex; flex-direction: column; gap: 2px;">
                      <tidy-text
                        [helper]="'Last Job'" />
                      <tidy-text
                        [body]="pro['Last Job'].value"
                        [translate]="false" />
                    </div>
                  }
                  @if (pro['Next Job'].value) {
                    <div style="display: flex; flex-direction: column; gap: 2px;">
                      <tidy-text
                        [helper]="'Next Job'" />
                      <tidy-text
                        [body]="pro['Next Job'].value"
                        [translate]="false" />
                    </div>
                  }
                </tidy-row>
              }
            </tidy-card>
          }
          @if (!shownPros?.length) {
            <tidy-alert>
              <tidy-row>
                <tidy-text
                  [body]="'No pros found.'" />
              </tidy-row>
            </tidy-alert>
          }
        }
      }

      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
    }

    @if (selectedTab === 'guests') {
      <customer-guests-tab />
    }

    @if (selectedTab === 'vendors') {
      <vendors-tab />
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="windowService.isDesktopRes" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />


@if (showAboutThisPage && selectedTab === 'pros') {
  <tidy-about-this-page [page]="'pros'" [overlayTop]="overlayTop" (dismissed)="dismissAboutThisPage()" />
}

<mat-menu #filterMenu="matMenu" class="filter-menu">
  <mat-tree [dataSource]="filterDataSource" [treeControl]="treeControl">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
      <button mat-menu-item matTreeNodeToggle class="tree-node-padding">
        <mat-checkbox
          class="checkbox"
          [checked]="getFilterNodeChecked(node)"
          (click)="$event.stopPropagation()"
          (change)="checkFilterNode(node, $event)">
          {{ node.name }}
        </mat-checkbox>
      </button>
    </mat-tree-node>
    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding>
      <button
        class="node-button-padding"
        mat-menu-item
        matTreeNodeToggle
        [attr.aria-label]="'Toggle ' + node.name">
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        {{ node.name }}
      </button>
    </mat-tree-node>
  </mat-tree>
</mat-menu>
